<template lang="pug">
.media-thumbnail(
  ref="observerTarget",
  @click="$emit('click')",
  :class="{ admin: adminMode }"
)
  .thumbnail-container(:class="{ admin: adminMode }")
    // Nur anzeigen, wenn erfolgreich geladen
    template(v-if="!loading && !loadError")
      .img(:style="{ backgroundImage: 'url(' + imageUrl + ')' }")
      .icon-overlay(v-if="isVideo")
        Icon.small(name="film")

    .loading(v-else-if="loading") Lade...
    .error(v-else) ⚠️ Fehler beim Laden
  .caption
    div(
      style="align-self: stretch; display: flex; justify-content: space-between; align-items: center;"
    )
      div(style="flex:1 0;text-align:left;") {{ index + 1 }}: {{ new Date(media.date_taken).toLocaleString() }}
      icon.small(
        v-if="adminMode && selected",
        name="checked",
        @click.stop="$emit('toggle', media.id)"
      ) 
      icon.small(
        v-if="adminMode && !selected",
        name="unchecked",
        @click.stop="$emit('toggle', media.id)"
      )
      div(style="width:6vw;")
    div(
      v-if="adminMode",
      style="display: flex; flex-flow: column; align-items: flex-start"
    )
      div Sichtbarkeit: {{ visibility[media.visibility] }}
      div MIME: {{ media.mime_type }}
      div {{ media.camera_model }}
      div {{ extractPath(media.source_path) }}
      div {{ extractName(media.file_path) }}
      .tagRow 
        .tag(v-for="t in media.tags") {{ t }}
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "MediaThumbnail",
  components: { Icon },
  props: ["index", "media", "adminMode", "selected"],
  data() {
    return {
      imageUrl: null,
      loading: false,
      loadError: false,
      isVisible: false,
      observer: null,
      visibility: {
        1: "gesperrt",
        2: "privat",
        3: "Freunde",
        4: "öffentlich",
      },
    };
  },
  computed: {
    isImage() {
      return this.media.mime_type.startsWith("image/");
    },
    isVideo() {
      return this.media.mime_type.startsWith("video/");
    },
  },
  mounted() {
    this.initObserver();
  },
  beforeDestroy() {
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    extractName(path) {
      return path.replace(/\\/g, "/").split("/").pop() || "";
    },
    extractPath(path) {
      const p = path.replace(/\\/g, "/").split("/") || "";
      p.pop();
      return p.join('/');
    },
    formatSize(bytes) {
      if (!bytes) return "–";
      const units = ["B", "KB", "MB", "GB"];
      let i = 0;
      while (bytes >= 1024 && i < units.length - 1) {
        bytes /= 1024;
        i++;
      }
      return `${bytes.toFixed(1)} ${units[i]}`;
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleString() : "";
    },
    initObserver() {
      if (!("IntersectionObserver" in window)) {
        this.isVisible = true;
        this.fetchMedia();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.fetchMedia();
            this.observer.disconnect();
          }
        },
        {
          root: null,
          threshold: 0.1,
        }
      );
      console.log("observer target:", this.$refs);
      this.observer.observe(this.$refs.observerTarget);
    },
    async fetchMedia() {
      if (!this.isVisible || this.imageUrl || this.loadError) return;

      this.loading = true;
      try {
        const response = await fetch(
          `https://gnatowski.ddns.net/api/media/thumbnail/${this.media.id}`
        );
        const blob = await response.blob();
        if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
        this.imageUrl = URL.createObjectURL(blob);
      } catch (err) {
        console.error(`Fehler beim Laden der Datei ${this.media.id}`, err);
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.media-thumbnail {
  position: relative;
  border: 1px solid #ccc;
  padding: 0.25rem;
  background: #fdfdfd;

  .thumbnail-container {
    position: relative;
    display: flex;
    flex-flow: column;

    .img {
      width: 30vw;
      height: 30vw;
      display: block;

      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .icon-overlay {
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      background: rgba(0, 0, 0, 0.6);
      color: white;
      padding: 0.2rem 0.4rem;
      font-size: 0.75rem;
      border-radius: 0.25rem;
    }

    input.checkbox {
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      z-index: 5;
    }
  }
  .thumbnail-container.admin {
    // width:40vw;
    // height: 40vw;
    flex: 0 0 auto;
    display: flex;
    .img {
      width: 40vw;
      height: 40vw;
    }
  }
  .caption {
    font-size: 3vw;
    margin-top: 0.25rem;
    margin-left: 2vw;
    word-break: break-word;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    flex:1 0;
  }
}
.media-thumbnail.admin {
  display: flex;
  flex-flow: row;
  align-items: flex-start;
}
.tagRow {
  display: flex;
  flex-flow: row wrap;
}
.tag {
  border: 1px solid gray;
  border-radius: 3px;
  padding: 0.1vw 1vw;
  margin: 0.5vw;
  background: #efe;
}
</style>
